import React from "react";
import _ from "lodash";
import timeAgo from "simple-timeago.handle-bad-input";
import MessageWithRedactedContact from "../modals/MessageWithRedactedContact";

import "./Message.less";

export default React.createClass({
  getInitialState: function () {
    return {
      show_redacted_contact_modal: false
    };
  },
  __toggleRedactedContactModal: function () {
    this.setState({
      show_redacted_contact_modal: !this.state.show_redacted_contact_modal
    });
  },

  handleClick: function () {
    let {
          onMarkAsRead,
          id
        } = this.props;
    //console.log("Message.js", "handleClick", id, !_.isEmpty(id), _.isFunction(onMarkAsRead));
    if (_.isFunction(onMarkAsRead)) {
      return onMarkAsRead([id]);
    }
  },
  render() {
    let {
      sender_name,
      is_you,
      is_unread,
      timestamp,
      content,
      blur_message = false,
      justified          = true,
      is_marketplace_message,
      contact_info_found = false,
      onMarkAsRead
    } = this.props;

    //console.log("Message.js", _.isFunction(onMarkAsRead));
    let received_date = timeAgo(timestamp);
    // let received_date = moment(timestamp).calendar(null, {
    //     sameDay: '[Today at] h:mm a',
    //     nextDay: '[Tomorrow]',
    //     nextWeek: 'dddd',
    //     lastDay: '[Yesterday at] h:mm a',
    //     lastWeek: '[Last] dddd [at] h:mm a',
    //     sameElse: 'MMM D, YYYY [at] h:mm a'
    // });
    if (is_marketplace_message) {
      return (
        <div className="row MP-Message">
          <div className="col-xs-8 col-xs-offset-2">
            <div className="strike">
              <div className="mp">
                <div><span dangerouslySetInnerHTML={{__html: content}}/></div>
                <div className="footer">
                  <span>{received_date}</span>
                  {is_unread &&
                  <div>{(_.isFunction(onMarkAsRead)) ? <a style={{marginRight: "0.5rem", cursor: "pointer"}} onClick={this.handleClick}>mark read</a> : null} <span className="label label-danger" style={{marginLeft: "1em"}}>NEW</span></div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="row MP-Message">
        <div className={"col-xs-12 " + (justified ? "col-sm-11 " + (is_you ? "col-sm-offset-1" : "") : "")}>
          <div className={"panel panel-default " + (is_you ? "spkr" : "me")}>
            <div className="panel-body">
              <div style={{whiteSpace: "pre-wrap"}} className="text-left">
                {blur_message
                ?
                  <span style={{filter: "blur(4px)"}} dangerouslySetInnerHTML={{__html: content.replace(/[A-Za-z0-9]/g, "#")}} />
                :
                  <span dangerouslySetInnerHTML={{__html: content}}/>
                }

              </div>
            </div>
            <div className="panel-footer">
              {is_you
                ? <i>Sent by you{" "}{received_date}</i>
                : <i>Sent from{" "}{sender_name}{" "}{received_date}</i>
              }
              {is_unread &&
              <div>{(_.isFunction(onMarkAsRead)) ? <a style={{marginRight: "0.5rem", cursor: "pointer"}} onClick={this.handleClick}>mark read</a> : null} <span className="label label-danger" style={{marginLeft: "1em"}}>NEW</span></div>
              }
            </div>
            {contact_info_found &&
            <div className={"panel-footer text-warning"}>
              Contact information was detected in this message before it was sent.
              {/*<i style={{cursor: "pointer"}} onClick={this.__toggleRedactedContactModal} className="fa fa-question-circle"/>*/}
            </div>
            }
          </div>
        </div>
        {this.state.show_redacted_contact_modal && MessageWithRedactedContact({onClose: this.__toggleRedactedContactModal})}
      </div>
    );
  }
});


// WEBPACK FOOTER //
// ./src/components/marketplace/Message.js